import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import {
  fetchModelTypes,
  selectModelTypes,
  fetchModelInstances,
  selectModelInstances
} from 'ducks/quicksearch';

import PageWithoutSideMenu from 'components/PageWithoutSideMenu';
import {
  default as LoginRequired,
  LoginRequiredProps
} from 'components/LoginRequired';
import Button from 'components/Button';
import Select from 'components/Select';
import {requiresPermission, PERMISSIONS} from 'ducks/auth';
import VisibleIf from 'components/VisibleIf';
import {ModelInstancesTable, SearchInput} from './components';

import './styles.css';

class QuickSearch extends React.Component<
  LoginRequiredProps &
    ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps
> {
  state = {
    objectId: null,
    modelType: null
  };

  componentDidMount() {
    this.props.requiresPermission({
      permission: PERMISSIONS.VIEW_QUICKSEARCH
    });
    this.props.fetchModelTypes();
  }

  searchOnChange = event => {
    this.setState({objectId: event.target.value});
  };

  selectOnChange = event => {
    this.setState({modelType: _.get(event, 'value', null)});
  };

  getModelInstances = () => {
    const {objectId, modelType} = this.state;

    let modelTypeData = {};
    if (modelType) {
      modelTypeData = {modelType};
    }

    this.props.fetchModelInstances({objectId, ...modelTypeData});
  };

  handleEnter = event => {
    if (event.charCode === 13) {
      this.getModelInstances();
    }
  };

  render() {
    const selectOptions = this.props.modelTypes;
    const {modelType} = this.state;
    const {modelInstances} = this.props;

    return (
      <PageWithoutSideMenu>
        <VisibleIf permission={PERMISSIONS.VIEW_QUICKSEARCH}>
          <div className="QuickSearch">
            <div className="searchWrapper">
              <SearchInput
                placeholder="Enter Object ID"
                onSearchChange={this.searchOnChange}
                onKeyPress={this.handleEnter}
              />
              <Select
                className="modelType"
                options={selectOptions}
                onChange={this.selectOnChange}
                value={modelType}
              />
              <Button blue onClick={this.getModelInstances}>
                Search
              </Button>
            </div>
            <ModelInstancesTable modelInstances={modelInstances} />
          </div>
        </VisibleIf>
      </PageWithoutSideMenu>
    );
  }
}

const mapStateToProps = state => {
  return {
    modelTypes: selectModelTypes(state),
    modelInstances: selectModelInstances(state)
  };
};

const mapDispatchToProps = {
  fetchModelTypes,
  fetchModelInstances,
  requiresPermission
};

export default connect(mapStateToProps, mapDispatchToProps)(
  LoginRequired(QuickSearch)
);
